<template>
  <div class="relative">
    <button
      class="btn-icon"
      :title="$t('components.landingpages.materialTrace.toggleDetail')"
      @click="isExpanded = !isExpanded"
    >
      <fa
        :icon="faHistory"
        fixed-width
      />
    </button>

    <div
      v-if="isExpanded"
      class="absolute right-0 z-20 w-96 max-h-96 p-3 overflow-y-auto text-xs text-left bg-white border rounded shadow-lg"
    >
      <h5 class="mb-2 font-semibold text-gray-800">
        {{ $t('components.landingpages.materialTrace.title') }}
      </h5>

      <p v-if="$apollo.queries.materialTraceHistory.loading">
        {{ $t('components.landingpages.materialTrace.loading') }}
      </p>
      <p
        v-else-if="$apollo.queries.materialTraceHistory.error"
        class="text-yellow-700"
      >
        {{ $t('components.landingpages.materialTrace.unavailable') }}
      </p>
      <p
        v-else-if="!materialTraceHistory.length"
        class="text-gray-600"
      >
        {{ $t('components.landingpages.materialTrace.empty') }}
      </p>
      <ol
        v-else
        class="space-y-2"
      >
        <li
          v-for="event in materialTraceHistory"
          :key="event.id"
          class="pb-2 border-b last:border-0"
        >
          <div class="flex justify-between space-x-2 text-gray-800">
            <span>{{ eventLabel(event.eventType) }}</span>
            <time class="text-gray-500">{{ formatDateTime(event.occurredAt) }}</time>
          </div>
          <p
            v-if="event.failureCode"
            class="mt-1 text-red-700"
          >
            {{ $t('components.landingpages.materialTrace.failure', { code: event.failureCode }) }}
          </p>
          <p class="mt-1 text-gray-600">
            <span v-if="event.bottimmoVersionNumber !== null">
              {{ $t('components.landingpages.materialTrace.version', { version: event.bottimmoVersionNumber }) }}
            </span>
            <span v-if="event.checksumSha256">
              {{ $t('components.landingpages.materialTrace.checksum', { value: abbreviated(event.checksumSha256) }) }}
            </span>
            <span v-if="event.recipeRevisionId">
              {{ $t('components.landingpages.materialTrace.recipe', { revision: event.recipeRevisionId }) }}
            </span>
          </p>
          <p
            v-if="event.quality"
            class="mt-1 text-gray-600"
          >
            {{ $t('components.landingpages.materialTrace.quality', {
              errors: event.quality.errorCount,
              warnings: event.quality.warningCount
            }) }}
          </p>
          <p
            v-if="event.diagnostic && event.diagnostic.materialMakerMaterialId"
            class="mt-1 text-gray-500"
          >
            {{ $t('components.landingpages.materialTrace.diagnostic', {
              authority: event.diagnostic.authority,
              materialId: event.diagnostic.materialMakerMaterialId
            }) }}
          </p>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import { faHistory } from '@fortawesome/free-solid-svg-icons'
import GET_MATERIAL_TRACE_HISTORY from '@/graphql/GetMaterialTraceHistory.gql'

export default {
  props: {
    materialId: {
      type: String,
      required: true
    },
    companyId: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      faHistory,
      isExpanded: false,
      materialTraceHistory: []
    }
  },

  apollo: {
    materialTraceHistory: {
      query: GET_MATERIAL_TRACE_HISTORY,
      variables () {
        return { materialId: this.materialId, companyId: this.companyId }
      },
      skip () {
        return !this.isExpanded
      },
      fetchPolicy: 'cache-and-network'
    }
  },

  methods: {
    eventLabel (eventType) {
      return this.$t(`components.landingpages.materialTrace.event.${eventType}`)
    },

    abbreviated (checksum) {
      return `${checksum.slice(0, 12)}…`
    }
  }
}
</script>
